module.exports = __webpack_public_path__ + "static/media/dot.1c6deecf.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/pic/dot.PNG
// module id = 514
// module chunks = 0